import { Lightning } from "@lightningjs/sdk";
import { List } from "@lightningjs/ui";
import theme from "../../../../lib/theme";
import { MENU_WIDTH } from "../../../../lib/utils";
import { ChannelListBase } from "../ChannelListBase/ChannelListBase";

interface ChannelListSpec extends Lightning.Component.TemplateSpec {
    Container: {
        List: typeof List;
    };
}

export class ChannelListVertical
    extends ChannelListBase
    implements Lightning.Component.ImplementTemplateSpec<ChannelListSpec>
{
    static override _template(): Lightning.Component.Template<ChannelListSpec> {
        return {
            w: theme.layout.w - MENU_WIDTH,
            h: theme.layout.h,
            flex: { direction: "column" },
            collision: true,
            zIndex: 10,
            Container: {
                h: theme.layout.h,
                w: 617,
                x: 0,
                y: 0,
                clipping: true,
                collision: true,
                List: {
                    type: List,
                    collision: true,
                    direction: "column",
                    spacing: 24,
                    h: theme.layout.h,
                    w: 607,
                    y: 0,
                    x: 0,
                    scroll: { after: 2 },
                    gcThreshold: 24,
                    requestThreshold: 20,
                    enableRequests: true,
                    signals: { onRequestItems: true },
                    scrollTransition: {
                        duration: 0.3,
                        timingFunction: "cubic-bezier(0.4, 0, 0.2, 1)"
                    }
                }
            }
        };
    }

    readonly Container = this.getByRef("Container")!;

    protected override get _list(): List {
        return this.Container.getByRef("List")! as List;
    }

    override _init() {
        this._list._handleUp = this._handleUp.bind(this);
        this._list._handleDown = this._handleDown.bind(this);
    }

    override _handleUp() {
        const currentIndex = this._list.index;
        let newIndex = currentIndex - 1;

        while (newIndex >= 0 && this._list.items[newIndex]?.isGroupTitle) {
            newIndex--;
        }

        if (newIndex >= 0) {
            this._list.setIndex(newIndex);
            return true;
        }
        return false;
    }

    override _handleDown() {
        const currentIndex = this._list.index;
        let newIndex = currentIndex + 1;

        while (newIndex < this._list.items.length && this._list.items[newIndex]?.isGroupTitle) {
            newIndex++;
        }

        if (newIndex >= this._list.items.length) {
            for (let i = 0; i < this._list.items.length; i++) {
                if (!this._list.items[i]?.isGroupTitle) {
                    this._list.setIndex(i);
                    return true;
                }
            }
            return false;
        }

        this._list.setIndex(newIndex);
        return true;
    }
}
